"use client";

import { Text, Flex, Box } from "@radix-ui/themes";
import Image from "next/image";
import currentEnv from "../config/environment";
import React from "react";

const CopyRight: React.FC = () => {
  return (
    <Box className="flex flex-col justify-center items-center space-y-2 relative">
      <Text as="div" size="1" mb="2" className="text-[#999fa8]">
        Version {currentEnv.latestAppVersion}
      </Text>
      <Flex justify="center" width="100%">
        <Image
          className="relative"
          src="/mega-logo.webp"
          alt="logo"
          width={80}
          height={70}
        />
      </Flex>
      <Text as="div" size="1" mb="1" className="text-[#525d6d]">
        © {new Date().getFullYear()} - Mega Lifesciences PCL
      </Text>
      <Text as="div" size="1" mb="1" className="text-[#525d6d]">
        Made with ❤️ by Team Health@Home
      </Text>
    </Box>
  );
};

export default CopyRight;
